import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-search-box',
  standalone: true,
  imports: [FormsModule, MatIconModule],
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss'],
})
export class SearchBoxComponent implements OnInit, OnDestroy {
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();

  @Input() debounce = true;
  debounceTime = 800;

  @Output() search = new EventEmitter<string>();

  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.searchSubject.pipe(
      debounceTime(this.debounce ? this.debounceTime : 0),
      map(value => value.trim()),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe(value => this.search.emit(value));
  }

  typed(): void {
    this.valueChange.emit(this.value);

    if (!this.debounce) {
      this.search.emit(this.value);
      return;
    }

    this.searchSubject.next(this.value);
  }

  onEnter(): void {
    this.search.emit(this.value);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}